import { CommonModule, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResumeDataByID } from '@edtech-ui/core/models/resume-builder/get-resume-by-id';

@Component({
  selector: 'app-classic',
  standalone: true,
  imports: [NgStyle, CommonModule],
  templateUrl: './classic.component.html',
  styleUrl: './classic.component.scss'
})
export class ClassicComponent {

  @Input() data!: ResumeDataByID;
  @Input() color: string = '#000';
  @Input() font: string = '';

}